import { createContext, useContext, useEffect, useState } from "react";
import { t as tr } from "../lib/i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("sereno_lang") || "fr");

  useEffect(() => {
    localStorage.setItem("sereno_lang", lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const t = (key) => tr(lang, key);
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
